<template>
  <div class="a11y-root">
    <!-- Accessibility Toggle Button (Universal Accessibility Icon) -->
    <button
      class="a11y-fab"
      @click="panelOpen = !panelOpen"
      :title="panelOpen ? 'Yopish' : 'Koʻzi ojizlar versiyasi'"
      aria-label="Maxsus imkoniyatlar"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="32"
        height="32"
        fill="white"
      >
        <path
          d="M256 48a208 208 0 1 1 0 416 208 208 0 0 1 0-416zm0-48C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 120a40 40 0 1 0 0 80 40 40 0 0 0 0-80zm-96 136c0 8.8 7.2 16 16 16h32v96c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
        />
      </svg>
    </button>

    <!-- Top Accessibility Panel Bar -->
    <transition name="a11y-bar-slide">
      <div
        v-if="panelOpen"
        class="a11y-topbar"
        role="toolbar"
        aria-label="Maxsus imkoniyatlar paneli"
      >
        <div class="a11y-topbar__inner">
          <!-- Color Mode Previews -->
          <div class="a11y-modes">
            <button
              v-for="mode in colorModes"
              :key="mode.id"
              class="a11y-mode-btn"
              :class="{ 'a11y-mode-btn--active': activeMode === mode.id }"
              @click="setColorMode(mode.id)"
              :title="mode.label"
            >
              <div
                class="a11y-mode-preview"
                :class="'a11y-preview--' + mode.id"
              >
                <img
                  src="@/assets/img/logotip1.png"
                  alt=""
                  class="a11y-mode-img"
                />
              </div>
              <span class="a11y-mode-label">{{ mode.label }}</span>
            </button>
          </div>

          <!-- Checkboxes -->
          <div class="a11y-checks">
            <label class="a11y-check" @click.prevent="toggleImages">
              <span
                class="a11y-checkbox"
                :class="{ 'a11y-checkbox--on': noImages }"
              ></span>
              <span class="a11y-check-text">Rasmsiz</span>
            </label>
            <label class="a11y-check" @click.prevent="toggleReader">
              <span
                class="a11y-checkbox"
                :class="{ 'a11y-checkbox--on': readerOn }"
              ></span>
              <span class="a11y-check-text">Ekran suxandoni</span>
            </label>
          </div>

          <!-- Font Size Slider -->
          <div class="a11y-font">
            <span class="a11y-font-sm">Aa</span>
            <input
              type="range"
              class="a11y-slider"
              min="80"
              max="150"
              step="10"
              v-model.number="fontScale"
              @input="applyFont"
            />
            <span class="a11y-font-lg">Aa</span>
          </div>

          <!-- Reset -->
          <button
            class="a11y-reset"
            @click="resetAll"
            title="Asl holatga qaytarish"
          >
            <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor">
              <path
                d="M17.65 6.35A7.96 7.96 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
              />
            </svg>
            <span>Qaytarish</span>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "AccessibilityPanel",
  data() {
    return {
      panelOpen: false,
      activeMode: "normal",
      noImages: false,
      readerOn: false,
      fontScale: 100,
      colorModes: [
        { id: "normal", label: "RANGLI" },
        { id: "contrast", label: "KONTRAST" },
        { id: "grayscale", label: "RANGSIZ" },
        { id: "invert", label: "INVERT" },
      ],
      synth: null,
    };
  },
  mounted() {
    this.synth = window.speechSynthesis || null;
    this.loadState();
  },
  beforeDestroy() {
    this.detachReader();
  },
  methods: {
    /* ---- Color mode ---- */
    setColorMode(id) {
      this.activeMode = id;
      const h = document.documentElement;
      h.classList.remove("a11y-contrast", "a11y-grayscale", "a11y-invert");
      if (id !== "normal") h.classList.add("a11y-" + id);
      this.saveState();
    },

    /* ---- Images ---- */
    toggleImages() {
      this.noImages = !this.noImages;
      document.documentElement.classList.toggle(
        "a11y-no-images",
        this.noImages,
      );
      this.saveState();
    },

    /* ---- Screen reader ---- */
    toggleReader() {
      this.readerOn = !this.readerOn;
      this.readerOn ? this.attachReader() : this.detachReader();
      this.saveState();
    },
    attachReader() {
      document.addEventListener("click", this._speak, true);
    },
    detachReader() {
      document.removeEventListener("click", this._speak, true);
      if (this.synth) this.synth.cancel();
    },
    _speak(e) {
      if (e.target.closest(".a11y-root")) return;
      const txt = (e.target.innerText || e.target.alt || "")
        .trim()
        .substring(0, 300);
      if (!txt || !this.synth) return;
      this.synth.cancel();
      const u = new SpeechSynthesisUtterance(txt);
      u.lang = "uz-UZ";
      u.rate = 0.9;
      this.synth.speak(u);
    },

    /* ---- Font scale ---- */
    applyFont() {
      const h = document.documentElement;
      if (this.fontScale === 100) {
        h.classList.remove("a11y-font-scaled");
        h.style.removeProperty("--a11y-font-scale");
      } else {
        h.style.setProperty("--a11y-font-scale", this.fontScale / 100);
        h.classList.add("a11y-font-scaled");
      }
      this.saveState();
    },

    /* ---- Reset ---- */
    resetAll() {
      this.activeMode = "normal";
      this.noImages = false;
      this.fontScale = 100;
      if (this.readerOn) {
        this.readerOn = false;
        this.detachReader();
      }
      const h = document.documentElement;
      h.classList.remove(
        "a11y-contrast",
        "a11y-grayscale",
        "a11y-invert",
        "a11y-no-images",
        "a11y-font-scaled",
      );
      h.style.removeProperty("--a11y-font-scale");
      localStorage.removeItem("a11y");
    },

    /* ---- Persistence ---- */
    saveState() {
      localStorage.setItem(
        "a11y",
        JSON.stringify({
          m: this.activeMode,
          i: this.noImages,
          r: this.readerOn,
          f: this.fontScale,
        }),
      );
    },
    loadState() {
      try {
        const s = JSON.parse(localStorage.getItem("a11y"));
        if (!s) return;
        this.activeMode = s.m || "normal";
        this.noImages = !!s.i;
        this.readerOn = !!s.r;
        this.fontScale = s.f || 100;
        this.setColorMode(this.activeMode);
        if (this.noImages)
          document.documentElement.classList.add("a11y-no-images");
        if (this.fontScale !== 100) this.applyFont();
        if (this.readerOn) this.attachReader();
      } catch (_) {
        /* ignore */
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* ============ FAB Toggle Button ============ */
.a11y-fab {
  position: fixed;
  bottom: 20px;
  left: 20px;
  z-index: 10001;
  width: 60px;
  height: 60px;
  border: none;
  border-radius: 14px;
  background: linear-gradient(145deg, #5c35d2, #4527a0);
  box-shadow: 0 4px 20px rgba(69, 39, 160, 0.5),
    0 0 0 3px rgba(255, 255, 255, 0.15);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: scale(1.08);
    box-shadow: 0 6px 28px rgba(69, 39, 160, 0.65),
      0 0 0 4px rgba(255, 255, 255, 0.25);
  }
  &:active {
    transform: scale(0.96);
  }
}

/* ============ Top Bar Panel ============ */
.a11y-topbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10002;
  background: linear-gradient(90deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%);
  box-shadow: 0 3px 18px rgba(0, 0, 0, 0.28);
}

.a11y-topbar__inner {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  padding: 14px 20px;
  flex-wrap: wrap;
}

/* ---- Color mode buttons ---- */
.a11y-modes {
  display: flex;
  gap: 12px;
}

.a11y-mode-btn {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 0;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
}

.a11y-mode-preview {
  width: 100px;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.3);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.a11y-mode-btn--active .a11y-mode-preview {
  border-color: #ffd740;
  box-shadow: 0 0 0 2px #ffd740;
}

.a11y-mode-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Color mode preview filters */
.a11y-preview--contrast .a11y-mode-img {
  filter: contrast(2) brightness(1.1);
}
.a11y-preview--grayscale .a11y-mode-img {
  filter: grayscale(1);
}
.a11y-preview--invert .a11y-mode-img {
  filter: invert(1);
}

.a11y-mode-label {
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.a11y-mode-btn--active .a11y-mode-label {
  color: #ffd740;
}

/* ---- Checkboxes ---- */
.a11y-checks {
  display: flex;
  gap: 18px;
}

.a11y-check {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.a11y-checkbox {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.55);
  border-radius: 3px;
  background: transparent;
  display: inline-block;
  position: relative;
  flex-shrink: 0;
  transition: all 0.15s ease;
}

.a11y-checkbox--on {
  background: #ffd740;
  border-color: #ffd740;

  &::after {
    content: "";
    position: absolute;
    left: 4px;
    top: 1px;
    width: 5px;
    height: 9px;
    border: solid #0d47a1;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
}

/* ---- Font size slider ---- */
.a11y-font {
  display: flex;
  align-items: center;
  gap: 8px;
}

.a11y-font-sm {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 600;
}
.a11y-font-lg {
  font-size: 22px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 700;
}

.a11y-slider {
  -webkit-appearance: none;
  appearance: none;
  width: 150px;
  height: 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.22);
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    cursor: pointer;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  }
  &::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #fff;
    border: none;
    cursor: pointer;
  }
}

/* ---- Reset button ---- */
.a11y-reset {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
  padding: 6px 14px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.22);
  }
}

/* ============ Slide Transition ============ */
.a11y-bar-slide-enter-active,
.a11y-bar-slide-leave-active {
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.a11y-bar-slide-enter,
.a11y-bar-slide-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

/* ============ Responsive ============ */
@media (max-width: 820px) {
  .a11y-topbar__inner {
    gap: 14px;
    padding: 10px 12px;
  }
  .a11y-mode-preview {
    width: 72px;
    height: 45px;
  }
  .a11y-slider {
    width: 100px;
  }
}

@media (max-width: 540px) {
  .a11y-topbar__inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
  .a11y-modes {
    width: 100%;
    justify-content: space-between;
  }
  .a11y-mode-preview {
    width: 60px;
    height: 38px;
  }
  .a11y-checks {
    width: 100%;
  }
  .a11y-font {
    width: 100%;
  }
  .a11y-slider {
    flex: 1;
  }
  .a11y-fab {
    width: 50px;
    height: 50px;
    border-radius: 12px;
  }
  .a11y-fab svg {
    width: 26px;
    height: 26px;
  }
}
</style>
